export function normalizeSearchParam(value: string | null): string | null {
  if (value === null) {
    return null;
  }

  const normalized = value.trim();
  return normalized === '' ? null : normalized;
}

export function buildPathWithMergedSearch(
  pathname: string,
  currentSearch: string,
  nextParams?: Record<string, string | null | undefined>,
): string {
  const searchParams = new URLSearchParams(currentSearch);

  if (nextParams) {
    for (const [key, value] of Object.entries(nextParams)) {
      if (value === null || value === undefined || value === '') {
        searchParams.delete(key);
      } else {
        searchParams.set(key, value);
      }
    }
  }

  const search = searchParams.toString();
  return search ? `${pathname}?${search}` : pathname;
}
